import { Raffle } from "../views/Raffles/interfaces";

export const INIT_RAFFLE: Raffle = {
  id: "",
  name: "",
  description: "",
  finalDate: null,
  promotions: [],
  images: [],
  image: null,
  active: false,
  priceTicket: 0,
  countTickets: 0,
  activeDate: true,
  tickets: []
};

export const baseUrlApi = "https://api-kzd2e7lszq-uc.a.run.app";

export const states = [
  'Aguascalientes',
  'Baja California',
  'Baja California Sur',
  'Campeche',
  'Chiapas',
  'Chihuahua',
  'Coahuila',
  'Colima',
  'Ciudad de México',
  'Durango',
  'Guanajuato',
  'Guerrero',
  'Hidalgo',
  'Jalisco',
  'Estado de México',
  'Michoacán',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Querétaro',
  'Quintana Roo',
  'San Luis Potosí',
  'Sinaloa',
  'Sonora',
  'Tabasco',
  'Tamaulipas',
  'Tlaxcala',
  'Veracruz',
  'Yucatán',
  'Zacatecas',
];